import script from "./Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Editor.vue?vue&type=script&setup=true&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=2451676a&scoped=true&lang=css"

import exportComponent from "/home/sergio/Escritorio/VSCode/Rosepetal/0.5.x-sergio/rosepetal-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2451676a"]])

export default __exports__